module.exports = __webpack_public_path__ + "img/awards.b3c3b457.png";